import { useEffect } from "react";
import { useSubscriptionStore } from "@/stores/subscriptionStore";

export function useBilling() {
  const billingState = useSubscriptionStore((state) => state.billingState);
  const checkout = useSubscriptionStore((state) => state.checkout);
  const hydrateBilling = useSubscriptionStore((state) => state.hydrateBilling);
  const openBillingPortal = useSubscriptionStore((state) => state.openBillingPortal);
  const refreshCredits = useSubscriptionStore((state) => state.refreshCredits);

  useEffect(() => {
    void hydrateBilling();
  }, [hydrateBilling]);

  return {
    billingState,
    checkout,
    hydrateBilling,
    openBillingPortal,
    refreshCredits,
  };
}
